import React, { useState } from "react";
import { Badge, User } from "@ecologi/shared";
import { Modal, ModalContent } from "../../DeprecatedModal";
import { PopupShareView } from "./PopupShareView";
import { AchievementProgressBar } from "./AchievementProgressBar";
import styles from "../styles/AchievementPopup.module.scss";
import badgeStyles from "../styles/AchievementBadge.module.scss";
import { climateBadgeIds } from "../consts/climate-badges";

const getShareImageUrl = (badge: Badge) => {
  let id: string = badge.id;

  if (climateBadgeIds.includes(id)) {
    id = id.replace("Positive", "Impact");
  }

  return `https://offset-earth-share-images.s3-eu-west-1.amazonaws.com/achievements/share_${id}.png`;
};

interface Props {
  badge: Badge;
  onClose: () => void;
  user: User;
}

export const AchievementPopup = ({ badge, onClose, user }: Props) => {
  const [isShareState, setIsShareState] = useState(false);

  const isComplete = user.isBadgeComplete(badge.id);

  const shareImageUrl = getShareImageUrl(badge);

  return (
    <Modal isOpen onClose={onClose} data-testid="badge-modal">
      <div className={styles.achievementPopupInner}>
        {isShareState && (
          <button
            className={styles.backButton}
            onClick={() => setIsShareState(false)}
            title="Go back"
            type="button"
          />
        )}
        {isShareState ? (
          <PopupShareView badge={badge} user={user} />
        ) : (
          <ModalContent>
            <div
              className={badgeStyles.achievementBadgeButton}
              data-badge-category={badge.category}
              data-badge-id={badge.id}
              data-complete={isComplete}
              data-static="true"
              data-large="true"
              data-100="true"
            />
            <h3 className={styles.title}>{badge.title}</h3>
            <div className={styles.copy}>
              {isComplete ? (
                <>
                  {badge.copy}
                  <br />
                  <br />
                  <a
                    className="link"
                    download
                    href={shareImageUrl}
                    rel="noopener noreferrer"
                    style={{ fontWeight: "bold", marginBottom: "12px" }}
                    target="_blank"
                  >
                    Download shareable image
                  </a>
                </>
              ) : (
                <AchievementProgressBar badge={badge} user={user} />
              )}
            </div>
          </ModalContent>
        )}
      </div>
    </Modal>
  );
};
